<script setup>
import {usePortalContentAndDesignStore} from "../../../../stores/partners/portalContentAndDesignStore";

const portalContentAndDesignStore = usePortalContentAndDesignStore();

</script>

<template>
    <div class="divide-y">
        <div class="pb-6 space-y-3">
            <div class="space-y-2">
                <h3 class="text-lg font-medium">Landing pate details</h3>
                <p class="text-gray-500 text-sm">The heading and the description of your landing page.</p>
            </div>
            <text-field
                label="Title"
                name="portal_landing_title"
                type="text"
                v-model="portalContentAndDesignStore.landingPageSettings.landing_page_resources.general.introduction"
            >
            </text-field>
            <text-editor
                name="portal_landing_description"
                :text="portalContentAndDesignStore.landingPageSettings.landing_page_resources.general.description"
                @input="(newValue) => { portalContentAndDesignStore.landingPageSettings.landing_page_resources.general.description = newValue }"
            >
            </text-editor>

            <radio-group-inline
                label="Branding"
                v-model="portalContentAndDesignStore.landingPageSettings.landing_page_resources.general.program_branding_type"
                :options="[
                { value: 'symbol', label: 'Symbol'},
                { value: 'logo', label: 'Logo'}
            ]"
            >
                <template #note>
                    Select which image to display alongside the program summary.
                </template>
            </radio-group-inline>
        </div>
        <div class="py-6">
            <div class="space-y-4">
                <toggle
                    size="default"
                    v-model="portalContentAndDesignStore.landingPageSettings.landing_page_resources.general.display_signup_and_login_links"
                    title="Include links for sign-up and log-in"
                >
                    <template #description>
                        Display links for sign-up and log-in under the program description.
                    </template>
                </toggle>

                <toggle
                    v-if="portalContentAndDesignStore.landingPageSettings.leads_enabled ?? false"
                    size="default"
                    v-model="portalContentAndDesignStore.landingPageSettings.landing_page_resources.general.display_submit_lead_link"
                    title="Include a lead submission link"
                >
                    <template #description>
                        Display a link for lead submission.
                    </template>
                </toggle>

                <toggle
                    size="default"
                    v-model="portalContentAndDesignStore.landingPageSettings.landing_page_resources.general.show_footer"
                    title="Include footer"
                >
                    <template #description>
                        The footer is designed with your brand’s signature color and features links for sign-up and log-in.
                    </template>
                </toggle>

                <toggle
                    size="default"
                    v-model="portalContentAndDesignStore.landingPageSettings.landing_page_resources.general.display_commission"
                    title="Show commission"
                >
                    <template #description>
                        Include the program commission structure under the program description.
                    </template>
                </toggle>
            </div>
        </div>
    </div>
</template>
